export const RESENAS = [
  { nombre: "María L.", texto: "Me cambiaron la pantalla del iPhone en menos de una hora. Precio justo y buen trato.", servicio: "Pantalla iPhone", ini: "ML" },
  { nombre: "Roberto G.", texto: "El personal es súper amable. Me arreglaron el móvil en el momento mientras hacía otras compras.", servicio: "Reparación Móvil", ini: "RG" },
  { nombre: "Ana P.", texto: "Contraté la fibra con ellos y todo perfecto. Me explicaron las tarifas sin presión.", servicio: "Fibra Óptica", ini: "AP" },
];
